import React, { useState, useEffect }  from 'react';
import PostRequest from 'components/common/PostRequest.jsx';
import QuoteBuilderNavSection from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderNavSection.jsx';


const SelectedList = ( { config, selectedList, setSelectedList, index } ) => {
  const [navSections, setNavSections] = useState( [] );
  const [payload, setPayload] = useState( {});
  const [presentedOptions, setPresentedOptions] = useState( {});

  const fetchNavSections = () => {
    if(selectedList.length == 0) {
      setNavSections( () => [] )
      return;
    }

    PostRequest({
      url: `/layouts-nav-section-combination-select-lists`,
      data: {
        index: index,
        user_quote_id: window.user_quote_id,
        id: window.drawingId,
        formula_options: window.dielineOptions,
        lists: selectedList,
      },
      callback: (data) => {
        setNavSections( () => data.nav_sections )
        window.nav_sections = data.nav_sections;
        setPayload( () => data.payload )
        setPresentedOptions( () => data.presented_options )
      }
    })
  }

  // useEffect starts
  useEffect(fetchNavSections, [selectedList] )
  // useEffect ends

  return (
    <div>
      {navSections.map((navSection, _index) => {

        if(navSection.part_type == 'general') { return }

        return (
          <div className="row" key={`row_${_index}`}>
            <QuoteBuilderNavSection
              index={index}
              config={config}
              payload={payload}
              presentedOptions={{presentedOptions}}
              key={`navSection_${_index}`}
              navSection={navSection}
              selectedList={selectedList}
              setSelectedList={setSelectedList}
            />
          </div>
        )
      })}

    </div>
  )
}

export default SelectedList;
